import LegacySupport from './LegacySupport.component';

export default LegacySupport;